import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { TFunction } from "i18next"
import { Tooltip } from "primereact/tooltip"

export const AsesoriaLogo = ({
  t,
  logoAsBase64,
  razonSocial,
}: {
  t: TFunction
  logoAsBase64?: string
  razonSocial?: string
}) => {
  if (!logoAsBase64 && !razonSocial) return null

  return (
    <>
      <Tooltip
        target='.navEmpresaAsesoriaLogo'
        content={`${t("nav.consultingTooltip", { razonSocial })}`}
        position='bottom'
      />
      {logoAsBase64 ? (
        <div className='navEmpresaAsesoriaLogo tw-hidden xl:tw-grid tw-place-content-center tw-h-16 tw-border-l tw-border-solid'>
          <img
            className='tw-px-5 tw-max-h-10 tw-max-w-60'
            alt='logoAsesoria'
            src={logoAsBase64}
          />
        </div>
      ) : (
        <div className='navEmpresaAsesoriaLogo tw-hidden xl:tw-flex tw-flex-row tw-gap-2 tw-justify-center tw-h-16 tw-border-l tw-border-solid tw-px-5'>
          <div className='tw-self-center tw-w-6 tw-h-6 tw-px-2 lg:tw-px-0'>
            <FontAwesomeIcon
              icon={["fal", "handshake"]}
              className='tw-self-center tw-px-0.5'
            />
          </div>
          <div className='tw-flex tw-flex-col tw-self-center tw-text-left tw-max-w-60'>
            <p className='tw-mb-0 tw-font-bold tw-text-xs tw-text-text-50 tw-uppercase'>
              {t("nav.consultingLabel")}
            </p>
            <p className='tw-mb-0 tw-font-normal tw-text-base tw-text-text tw-text-nowrap tw-text-ellipsis tw-overflow-hidden tw-max-w-60'>
              {razonSocial}
            </p>
          </div>
        </div>
      )}
    </>
  )
}
